import React from "react";
import SearchBox from "../../ui/SearchBox";

export default function(props: any) {
  return <SearchBox innholdstype="yrke" />;
}
